<template>
    <section class="position-relative bg-white" id="hero">
        <div
            class="text-container max-w-md text-center position-absolute start-50 translate-middle-x d-flex flex-column gap-2 gap-sm-3 px-3 px-md-4 px-lg-0"
        >
            <h1 class="text-dark">Euro Petrol aplikacija</h1>
            <p>
                Nova mobilna aplikacija omogućava da na jednostavan način
                <strong>
                    uživaš u pogodnostima pri kupovini goriva, Lion Expert
                    proizvoda i usluga.
                </strong>
                Instaliraj aplikaciju, registruj se, postani član Euro Petrol
                kluba lojalnosti i <strong>uštedi pri svakoj kupovini!</strong>
            </p>
        </div>
        <div class="hero-image-wrapper relative">
            <img
                class="new-badge"
                src="/img/application/vector/new-badge.svg"
                alt="Nova Verzija"
            />
            <img
                width="1440"
                height="773"
                loading="eager"
                class="hero-image mx-auto"
                src="/img/application/original/hero-image.webp"
                sizes="(min-width: 768px) 100vw, 175vw"
                srcset="
                    /img/application/sm/hero-image.webp    384w,
                    /img/application/lg/hero-image.webp    512w,
                    /img/application/3xl/hero-image.webp   768w,
                    /img/application/5xl/hero-image.webp  1024w,
                    /img/application/7xl/hero-image.webp  1280w,
                    /img/application/8xl/hero-image.webp  1536w,
                    /img/application/9xl/hero-image.webp  1920w,
                    /img/application/10xl/hero-image.webp 2560w
                "
                alt="Početna stranica aplikacije"
            />
        </div>
        <div
            class="py-3 py-sm-5 d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 gap-sm-4"
        >
            <img
                src="/img/application/vector/google-play-download.svg"
                alt="Get it on Google Play"
            />
            <img
                src="/img/application/vector/app-store-download.svg"
                alt="Download on the App Store"
            />
            <img
                src="/img/application/vector/app-gallery-download.svg"
                alt="Explore it on AppGallery"
            />
        </div>
    </section>
</template>

<style scoped>
.text-container {
    width: 100%;
    top: 7%;
    z-index: 2;
}

.hero-image {
    display: block;

    width: auto;
    max-width: 100%;
    max-height: calc(100vh - 18rem);

    aspect-ratio: 16/9;
    object-fit: cover;
    object-position: center bottom;
    position: relative;
    z-index: 0;
}

.new-badge {
    position: absolute;

    top: 35%;
    transform: translate(0, -50%);
    right: calc((100vw - 1024px) / 2 + 4rem);
    z-index: 1;
}

@media (max-width: 1024px) {
    .text-container {
        top: 7%;
    }

    .new-badge {
        top: 42%;
        right: calc((100vw - 1024px) / 2 + 8rem);

        width: 8rem;
    }
}

@media (max-width: 768px) {
    .text-container {
        top: 0.5rem;
    }

    .hero-image {
        padding-top: 3rem;
        aspect-ratio: 4/3;
        width: 100%;
        max-height: 32rem;
    }

    .new-badge {
        right: 50%;
        top: 37%;
        transform: translate(50%, -50%);
    }
}

@media (max-width: 576px) {
    .text-container {
        top: 0.5rem;
    }

    .hero-image-wrapper {
        padding-top: 4rem;
    }

    .hero-image {
        max-height: 22.5rem;
    }

    .new-badge {
        top: 36%;
        width: 6rem;
    }
}

@media (max-width: 375px) {
    .new-badge {
        top: 40%;
        width: 5rem;
    }

    .hero-image-wrapper {
        padding-top: 5rem;
    }
}
</style>
